export default __webpack_public_path__ + "static/media/team120.31bdb2a0.JPG";